import { keyframes } from 'styled-components'
import { tokens } from './tokens'

export const ms = (duration: string) => parseInt(duration, 10)
export const REDUCE_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

export const prefersReducedMotion = () =>
    typeof window !== 'undefined' && Boolean(window.matchMedia?.(REDUCE_MOTION_QUERY).matches)
export const shouldWaitForMotion = () => !prefersReducedMotion()
export const shouldAnimateMotion = (requested: boolean) => requested && shouldWaitForMotion()

/**
 * Motion recipes built from `tokens.motion`, so every overlay and list change moves the same way.
 * Things arrive at `base` with ease-out and leave faster, at `fast` with ease-in.
 * globals.css switches all of it off under `prefers-reduced-motion`.
 */
export const Motion = {
    enter: `${tokens.motion.base} ${tokens.motion.easeOut}`,
    exit: `${tokens.motion.fast} ${tokens.motion.easeIn}`,
    // Side panels (nav, calendar) open and close at the same pace, easing out both ways.
    panel: `${tokens.motion.base} ${tokens.motion.easeOut}`,
    // Anchored menus and popovers start this far back toward their trigger, and slightly smaller.
    overlayOffset: '4px',
    overlayScale: 0.98,
    // A completed task fades, then its row closes so the rows below slide up instead of jumping.
    // The close ends exactly when the task leaves the list (TASK_MARK_AS_DONE_TIMEOUT).
    taskComplete: {
        fade: tokens.motion.fast,
        collapse: tokens.motion.base,
        collapseDelay: `${ms(tokens.motion.complete) - ms(tokens.motion.base)}ms`,
    },
}

export const fadeIn = keyframes`
    from {
        opacity: 0;
    }
`
export const fadeOut = keyframes`
    to {
        opacity: 0;
    }
`
